const keys = {
  allProjects: 'allProjects',
  allReports: 'allReports',
  project: 'project',
  projectVersions: 'projectVersions',
  projectVersion: 'projectVersion',
  projectLineItemsAndBudgets: 'projectLineItemsAndBudgets',
  divisions: 'divisions',
  caReport: 'caReport',
  associatedReports: 'associatedReports',
  recentProjects: 'recentProjects',
  userRecentProjects: 'userRecentProjects',
  recentReports: 'recentReports',
  userRecentReports: 'userRecentReports',
  lineitems: 'lineItems',
  projectDraws: 'projectDraws',
  projectAnalysis: 'projectAnalysis',
  compsAverages: 'compsAverages',
  comps: 'comps',
  ccReports: 'ccReports',
  ccReport: 'ccReport',
  qccReports: 'qccReports',
  qccReport: 'qccReport',
  limitedReport: 'limitedReport',
  limitedReportInvoice: 'limitedReportInvoice',
  invoiceHistory: 'invoiceHistory',
  projectHistory: 'projectHistory',
  files: 'files',
} as const;

export default keys;
